import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, exhaustMap, tap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as AuctionActions from './auction.actions';
import { AuctionManageService } from '../services/auction-manage/auction-manage.service';
import { Store } from '@ngrx/store';
import { ToastService } from 'app/toast/services/toast.service';

@Injectable()
export class CampaignAuctionEffects {

    loadAuction$ = createEffect(() => {
        return this.actions$.pipe( 
          ofType(AuctionActions.loadAuction),
          exhaustMap((action: any) => {
            return this.auctionManageService.getAuction(action.payload).pipe(
              map(data => {
               return AuctionActions.loadAuctionSuccess({ data })
              }
                ),
              catchError(error => of(AuctionActions.loadAuctionFailure({ error }))))
          })
        );
      });
    
    loadItemDetailInfo$ = createEffect(() => {
        return this.actions$.pipe( 
          ofType(AuctionActions.loadItemDetailInfo),
          exhaustMap((action: any) => {
            return  this.auctionManageService.getAuctionItemDetails(action.payload).pipe(
              map(data => AuctionActions.loadItemDetailInfoSuccess({ data })),
              catchError(error => of(AuctionActions.loadItemDetailInfoFailure({ error }))))
          })
        );
      });

    deleteBid$ = createEffect(()=> {
      return this.actions$.pipe(
        ofType(AuctionActions.deleteBid),
        exhaustMap((action: any) => {
          return this.auctionManageService.deleteBidById(action.payload.bidId).pipe(
            tap(() => {
              this.toastService.show('success', 'Deleted Successfully', {delay: 2000})
            }),
            switchMap(() => [
              AuctionActions.deleteBidSuccess({ data: action.payload.bidId }),
              AuctionActions.loadAuction({ payload: action.payload.campaignId }),
              AuctionActions.loadItemDetailInfo({ payload: action.payload.loadItemParams}),
            ]),
            catchError(error => of(AuctionActions.deleteBidFailure({ error }))))
        })
      );
    });

    deleteAutoBid$ = createEffect(()=> {
      return this.actions$.pipe(
        ofType(AuctionActions.deleteAutoBid),
        exhaustMap((action: any) => {
          return this.auctionManageService.deleteAutoBidById(action.payload.autoBidId).pipe(
            tap(() => {
              this.toastService.show('success', 'Deleted Successfully', {delay: 2000})
            }),
            switchMap(() => [
              AuctionActions.deleteAutoBidSuccess({ data: action.payload.autoBidId }),
              AuctionActions.loadAuction({ payload: action.payload.campaignId}),
              AuctionActions.loadItemDetailInfo({ payload: action.payload.loadItemParams}),
            ]),
            catchError(error => of(AuctionActions.deleteAutoBidFailure({ error }))))
        })
      );
    });

    updateBidder$ = createEffect(() => {
      return this.actions$.pipe( 
        ofType(AuctionActions.updateBidder),
        exhaustMap((action: any) => {
          return  this.auctionManageService.updateAuctionBidder(action.payload.params).pipe(
            tap(() => {
              this.toastService.show('success', 'Updated Successfully', {delay: 2000})
            }),
            switchMap(() => [
              AuctionActions.updateBidderSuccess({ data: action.payload.params }),
              AuctionActions.loadAuction({ payload: action.payload.campaignId}),
              AuctionActions.loadItemDetailInfo({ payload: action.payload.loadItemParams}),
            ]),
            catchError(error => of(AuctionActions.updateBidderFailure({ error }))))
        })
      );
    });

    loadBidActivity$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(AuctionActions.loadBidActivy),
        exhaustMap((action) => {
          return this.auctionManageService.loadBidActivity(action.campaignId, action.since).pipe(
            map((list: any[]) => AuctionActions.loadBidActivySuccess({bidActivityList:list}))
          )
        })
      )
    })

    loadPendingDonations$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(AuctionActions.loadPendingDonations),
        exhaustMap((action) => {
          return this.auctionManageService.loadPendingDonations(action.campaignId).pipe(
            map((list :any[]) => AuctionActions.loadPendingDonationsSuccess({pendingDonations: list}))
          )
        })
      )
    })

    loadPaidDonations$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(AuctionActions.loadPaidDonations),
        exhaustMap((action) => {
          return this.auctionManageService.loadPaidDonations(action.campaignId).pipe(
            map((list :any[]) => AuctionActions.loadPaidDonationsSuccess({paidDonations: list}))
          )
        })
      )
    })

    constructor(
      private actions$: Actions,
      private auctionManageService: AuctionManageService,
      private toastService: ToastService,
      private store: Store,
    ) {}
}